import React, { useEffect, useState } from 'react';

import styles from './StoryLessonV2.module.scss';
import MainMenu from "../MainMenu/MainMenu";
import OrbitElementsSimulator from "../OrbitElementsSimulator/OrbitElementsSimulator";
import TabbedModal from "../TabbedModal/TabbedModal";
import Button, { ButtonsHolder } from "../../../partials/Button";
import { OrbitsContext } from "../Context/OrbitsContext";
import BigGlobe from "../common/BigGlobe/BigGlobe";
import ContentBox from "../common/ContentBox/ContentBox";
import _ from "lodash";
import axios from "axios";
import { SimpleModal } from "../../../partials/Modal";
import HTMLContent from "../../../partials/HTMLContent";
import Scroll from "../../../partials/Scroll/Scroll";

var FIRST_RENDER_LOADING_FLAG = true;

const StoryLessonV2 = ({ orbits, stories, onBack = () => { }, onContinue = () => { }, onOrbitSelected = () => { } }) => {
    const orbitsState = React.useContext(OrbitsContext)
    const [currentSection, setCurrentSection] = useState(0)
    const [selectedOrbit, setSelectedOrbit] = useState(orbitsState.currentSelectedOrbit)
    const sections = stories[0].sections
    const doSelect = sections[currentSection].sectionOptions.orbitSelect === true
    const doOrbitMaker = sections[currentSection].sectionOptions.orbitMaker === true
    const doTabs = sections[currentSection].sectionOptions.orbitTabs === true
    const doBackButton = sections[currentSection].resetValue > -1
    const doBigGlobe = sections[currentSection].sectionOptions.doBigGlobe === true
    const isOutcome = sections[currentSection].sectionOptions.isOutcome === true
    const correct = sections[currentSection]?.correct || { header: 'Invalid Outcome', body: 'Invalid Outcome' }
    const incorrect = sections[currentSection]?.incorrect || { header: 'Invalid Outcome', body: 'Invalid Outcome' }
    const [shiftMR, setShiftMR] = useState(false)
    const [selectedUserValues, setSelectedUserValues] = React.useState();
    const [showMissionRequirements, setShowMissionRequirements] = useState(false)
    // Slider selected data
    const [currentSliderData, setCurrentSliderData] = useState()
    const [success, setSuccess] = React.useState(
        () => {
            return false
        }
    )

    const [orbitColor, setOrbitColor] = React.useState();
    const [errorMsg, setErrorMsg] = React.useState()
    const [currentSingleSelected, setCurrentSingleSelected] = useState()
    const [singleFeedback, setSingleFeedback] = useState('')

    useEffect(() => {
        FIRST_RENDER_LOADING_FLAG = false;

        return () => {
            FIRST_RENDER_LOADING_FLAG = true;
        }
    }, [])

    useEffect(() => {
        const isSimulation = sections[currentSection].nextButton.toLowerCase().includes('simulation')
        if (isSimulation && currentSliderData && orbitsState.storyData && orbitsState?.isSingleSlider !== true) {
            if (stories[0].correctOrbitData.correctOrbitDataSMA !== -1 &&
                stories[0].correctOrbitData.correctOrbitDataEccentricity !== -1 &&
                stories[0].correctOrbitData.correctOrbitDataInclination !== -1

            ) {

                setSuccess(_.isEqual({
                    sma: stories[0].correctOrbitData.correctOrbitDataSMA,
                    eccentricity: stories[0].correctOrbitData.correctOrbitDataEccentricity,
                    inclination: stories[0].correctOrbitData.correctOrbitDataInclination,
                },
                    currentSliderData
                ))
            }
        }

    }, [currentSliderData])

    let bigGlobeVariant = 'normal'
    const storyData = orbitsState.storyData
    const getValues = aspect => {
        try {
            const orbitGroundData = storyData
            const aspectValues = [...new Set(orbitGroundData.map(d => d[aspect]))]
            return aspectValues.sort(function (a, b) {
                return a - b
            })

        } catch (e) {
            console.log(e.message)
        } finally {
        }
        return [];
    }
    const smaValues = getValues('sma')
    const incValues = getValues('inc')
    const eccValues = getValues('ecc')
    if (isOutcome) {
        bigGlobeVariant = success ? 'success' : 'failure'
    }
    useEffect(() => {
        if (!selectedOrbit) return
        try {
            onOrbitSelected(selectedOrbit)
        } catch (e) {
            console.log(e.message)
        }
    }, [selectedOrbit])


    React.useEffect(() => {
        setShiftMR(sections[currentSection]?.sectionOptions?.doDownloadButton === true)
    }, [currentSection])
    useEffect(() => {
        orbitsState.setCurrentGoBackCallback(undefined)
    }, [])
    useEffect(() => {
    }, [success])
    if (!Array.isArray(stories) || stories.length === 0) {
        return null
    }

    const handleStartOrbit = (o) => {
        orbitsState.setCurrentSelectedOrbit(o)
        if (currentSection < sections.length - 1) {
            setCurrentSection(currentSection + 1)
        }
    }
    const handleSingleSelectChange = (single) => {
        setCurrentSingleSelected(single)
    }

    const handleOnNext = () => {
        const isSimulation = sections[currentSection].nextButton.toLowerCase().includes('simulation')
        if (isSimulation) {
            if (orbitsState?.config?.isSingleSlider === true) {
                const correct = orbitsState?.singleSliderValues.find(o => o.isCorrect === 'TRUE')
                setSuccess(currentSingleSelected === correct.value)
                setSingleFeedback(orbitsState?.singleSliderValues.find(o => o.value === currentSingleSelected)?.Feedback || 'Invalid Feedback')
            } else
                if (stories[0].correctOrbitData.correctOrbitDataSMA === -1 &&
                    stories[0].correctOrbitData.correctOrbitDataInclination === -1 &&
                    stories[0].correctOrbitData.correctOrbitDataEccentricity === -1
                ) {
                    setSuccess(stories[0].correctOrbit.trim().toLowerCase() === orbitsState.currentSelectedOrbit.header.trim().toLowerCase())
                } else {
                    const { pr, ...sliderData } = currentSliderData
                    setSuccess(_.isEqual({
                        sma: stories[0].correctOrbitData.correctOrbitDataSMA,
                        eccentricity: stories[0].correctOrbitData.correctOrbitDataEccentricity,
                        inclination: stories[0].correctOrbitData.correctOrbitDataInclination,
                    },
                        sliderData
                    ))
                }

        }
        if (currentSection < sections.length - 1) {
            setCurrentSection(currentSection + 1)
            return
        }
        onContinue()
    }

    const valuesValidation = (data, callback) => {
        const isSimulation = sections[currentSection].nextButton.toLowerCase().includes('simulation');

        if (isSimulation) {
            callback();
            return
        };

        setCurrentSliderData(data)
        if (!data.sma) return

        // setCurrentSelectedOrbitData(h)
        const orbitGroundData = orbitsState.storyData;
        if (!orbitGroundData) {
            console.warn('No story data')
            return
        }
        const smaTracks = orbitGroundData.filter(
            t => {
                return t.sma === data.sma &&
                    t.ecc === data.eccentricity &&
                    t.inc === data.inclination
            }
        )
        if (smaTracks.length < 1) {
            if (FIRST_RENDER_LOADING_FLAG === true) return;
            setOrbitColor(smaTracks.length < 1 ? "red" : undefined)
            setErrorMsg(smaTracks.length < 1 ? "Adjust your SMA, inclination or eccentricity in order to view another orbit" : undefined)
        } else {

            const failReason = smaTracks.find(t => t.isGood === false && t.reason !== '')
            if (failReason) {
                setErrorMsg(failReason.reason || 'Invalid Orbit')

            } else {
                setErrorMsg(undefined)
                setOrbitColor(undefined)
                callback();
            }
        }
    }

    return <div className={styles.Container}>
        <SimpleModal
            className={styles.RM_Modal}
            size={'md'}
            show={showMissionRequirements}
            showContinue={true}
            buttonText={'CLOSE'}
            scroll={false}
        >
            <Scroll className={styles.Fix_Scroll} >
                <HTMLContent html={orbitsState.config.stories[0]?.body} variant={'custom'} className={styles.Fix_Scroll_Content} >
                </HTMLContent>
            </Scroll>
            <ButtonsHolder orientation={'center'}>
                <Button text={'CLOSE'} onClick={() => setShowMissionRequirements(false)}></Button>
            </ButtonsHolder>
        </SimpleModal>
        {<div className="back-btn-container" style={{ zIndex: 10 }} onClick={() => {
            if (currentSection > 0) {
                setCurrentSection(currentSection - 1)
                return
            }
            onBack()
        }}>
            <Button variant={'back'} text={'BACK'} />
        </div>}
        {sections[currentSection]?.sectionOptions?.doDownloadButton === true && <div className={styles.DownloadButton} style={{ zIndex: 10 }} onClick={() => {
            download(`docs/${orbitsState.config.simulatorFile}`, orbitsState.config.simulatorFile)
        }}>
            <Button
                variant={'default'}
                text={sections[currentSection?.downloadButtonCaption] || 'DOWNLOAD TOOL'} />
        </div>}

        <div className={`${styles.MissionRequirements} ${shiftMR ? styles.shift : ''}`}>
            <Button text={shiftMR ? 'Mission Reqs' : 'Mission Requirements'}
                onClick={() => setShowMissionRequirements(true)}
            ></Button>
        </div>

        {/* <div className={styles.Header} >
           {sections[currentSection].header}
       </div> */}
        <div className={styles.MainContent}>
            {isOutcome && <div className={styles.Outcome}> <ContentBox
                variant={success ? 'success' : 'failure'}
                title={success ? correct.header : incorrect.header}
            >
                {orbitsState?.isSingleSlider === true &&
                    <HTMLContent html={singleFeedback}></HTMLContent>}
                {orbitsState?.isSingleSlider != true &&
                    <HTMLContent html={success ? correct.body : incorrect.body}></HTMLContent>}

            </ContentBox></div>}
            {doBigGlobe && <div className={styles.BigGlobe}>
                <div className={styles.TabbedContent}><BigGlobe
                    relax
                    variant={bigGlobeVariant}
                    data={selectedOrbit}
                />
                </div>

            </div>}
            {doSelect && <div className={styles.Selector}>
                <MainMenu
                    orbits={orbits}
                    defaultOrbit={orbitsState?.config?.selectedOrbit}
                    continueButtonCaption={sections[currentSection].nextButton}
                    onStartOrbit={handleStartOrbit}
                    light={true}
                    instructions={orbitsState.config?.instructions || ""}
                />
            </div>}
            <div className={styles.OrbitMaker}>
                {doOrbitMaker && <OrbitElementsSimulator
                    sma={orbitsState?.currentSelectedOrbit?.orbitData.sma || currentSliderData?.sma}
                    ecc={(orbitsState?.currentSelectedOrbit?.orbitData.ecc !== undefined) ? orbitsState?.currentSelectedOrbit?.orbitData.ecc : currentSliderData?.eccentricity}
                    inc={(orbitsState?.currentSelectedOrbit?.orbitData.inc !== undefined) ? orbitsState?.currentSelectedOrbit?.orbitData.inc : currentSliderData?.inclination}
                    isSingleSlider={orbitsState?.isSingleSlider === true}
                    singleSliderValues={orbitsState?.singleSliderValues || []}
                    onSingleSelectChange={handleSingleSelectChange}
                    SMAValues={smaValues}
                    InclinationValues={incValues}
                    EccentricityValues={eccValues}
                    showSliders={sections[currentSection].sectionOptions.doSliders}
                    showGroundData={sections[currentSection].sectionOptions.doGroundData}
                    orbit={orbitsState.currentSelectedOrbit}
                    orbitColor={orbitColor}
                    errorMsg={errorMsg}
                    onErrorClick={() => {
                        setErrorMsg(undefined)
                        setOrbitColor(undefined)
                    }}
                    onSlidersChange={(data) => {
                        setCurrentSliderData(data);
                        setSelectedUserValues(data);
                        // validation(data);
                    }}
                />}
            </div>
            <div className={styles.OrbitContent}>
                <div className={styles.Spacer} />
                {doTabs && <div className={styles.TabbedContent}><TabbedModal
                    relax
                    data={orbitsState.currentSelectedOrbit}
                />
                </div>}
            </div>
            {!doSelect && sections[currentSection]?.nextButton && <div
                className={`${styles.ActionButton}
                 ${isOutcome || sections[currentSection].nextButton.toLowerCase().includes('simulation') ? styles.middle : ''}`}>
                {doBackButton && !(isOutcome && success) && <Button onClick={() => {
                                            setErrorMsg(undefined)
                                            setOrbitColor(undefined)
                    if (sections[currentSection].resetValue > -1 && sections[currentSection].resetValue < sections.length - 1) {
                        setCurrentSection(sections[currentSection].resetValue)
                        return
                    }
                    if (currentSection > 0) {
                        setCurrentSection(currentSection - 1)
                        return
                    }
                    if (onBack) {
                        onBack()
                    }
                }
                }
                    text={sections[currentSection].retryButton}
                />}
                <Button onClick={() => {
                    valuesValidation(selectedUserValues, handleOnNext)
                }}
                    text={sections[currentSection].nextButton}
                >
                </Button>
            </div>}
        </div>
    </div>

}

function download(url, fileName) {
    axios({
        url: url,
        method: 'GET',
        responseType: 'blob'
    })
        .then((response) => {
            const url = window.URL
                .createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        })
        .catch(e => {
            console.error(e.message);
            alert('Unable to download file');
        })
}

export default StoryLessonV2;
